import axios from "axios";

const request = axios.create({
	url: "/ajax/",
	baseURL: "/api/levels/",
	headers: { "X-Requested-With": "XMLHttpRequest" },
});

const roomsRequest = axios.create({
	url: "/ajax/",
	baseURL: "/api/rooms/",
	headers: { "X-Requested-With": "XMLHttpRequest" },
});

const layoutRequest = axios.create({
	url: "/ajax/",
	baseURL: "/api/layouts/",
	headers: { "X-Requested-With": "XMLHttpRequest" },
});

const roomRequest = axios.create({
	url: "/ajax/",
	baseURL: "/api/room/",
	headers: { "X-Requested-With": "XMLHttpRequest" },
});

let isLoadingFloorPlan = false;
let isLoadingRoomData = false;

export const getFlatsStep = ({ complexId, floorNumber }) => {
	return request
		.get(`?&complex=${complexId}&floor=${floorNumber}`)
		.then((response) => {
			return response.data;
		});
};

export const getFlatsStatus = ({ complexId, floorNumber }) => {
	return roomsRequest
		.get(`?mode=status-only&complex=${complexId}&floor=${floorNumber}`)
		.then((response) => {
			return response.data;
		});
};

export const getRoomData = async (roomId) => {
	if (isLoadingRoomData) {
		return;
	}

	isLoadingRoomData = true;

	try {
		const response = await roomRequest.get(`?room=${roomId}`);
		return response.data;
	} catch (error) {
		throw error;
	} finally {
		isLoadingRoomData = false;
	}
};

export const getFloorPlan = async ({ sectionId, floorNumber }) => {
	if (isLoadingFloorPlan) {
		return;
	}

	isLoadingFloorPlan = true;

	try {
		const response = await layoutRequest.get(
			`?section=${sectionId}&floor=${floorNumber}`
		);
		return response.data;
	} catch (error) {
		console.error("Error fetching floor plan:", error);
		throw error;
	} finally {
		isLoadingFloorPlan = false;
	}
};
